import { render, staticRenderFns } from "./UploadCover.vue?vue&type=template&id=25540718"
import script from "./UploadCover.vue?vue&type=script&lang=js"
export * from "./UploadCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports